import React, { useState, useEffect } from 'react';


const Root = props => {

  const url = typeof window !== 'undefined' ? window.location.href : '';

  useEffect(() => {
    if(url.includes("?")){
      let UTMparams = JSON.parse(sessionStorage.getItem('UTMparams')) || [];
      let newUTMparams = url.split("?")[1].split("&").map(property => property.split("=")) || [];

      if (UTMparams.length === 0){
        UTMparams = newUTMparams
      } else {

        let filetredUTMparams = [];

        for(let i = 0; i < newUTMparams.length; i++){
          let valueChanged = false;
          
          for(let j = i; j < UTMparams.length; j++){   
            if (newUTMparams[i][0] === UTMparams[j][0]){
              
              let previousValues = UTMparams[j][1].split(";");

              if (previousValues[previousValues.length-1] === newUTMparams[i][1]) {
              
                valueChanged = true;
                j = UTMparams.length;
              
              } else {

                UTMparams[j][1] = UTMparams[j][1] + ";" + newUTMparams[i][1];
                valueChanged = true;
                j = UTMparams.length;
              
              }
            }
          }
          if (!valueChanged){
            UTMparams.push(newUTMparams[i])
          }
        }
      }

      sessionStorage.setItem('UTMparams', JSON.stringify(UTMparams));    

    }

  }, [url])


  return (
    <React.Fragment>
      {props.children}
    </React.Fragment>
  )
}

export default Root
